// @flow
import appTrackers from './application/trackers';

export default [appTrackers];



// WEBPACK FOOTER //
// ./src/core/state/trackers-registration.js